import { render, staticRenderFns } from "./ViewPDF.vue?vue&type=template&id=00d2d405&"
import script from "./ViewPDF.vue?vue&type=script&lang=js&"
export * from "./ViewPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports